<template>
    <div class="group-list">
        <h2>Manage Groups</h2>
        <button @click="$router.push('/dashboard/groups/add')" class="btn btn-primary btn-sm mb-2 add-group-btn">Add
            Group</button>

        <div v-for="group in groups" :key="group.id" class="group-card" @click="selectGroup(group)"
            :class="{ 'selected': selectedGroup?.id === group.id }">
            <p><strong>Group Name:</strong> {{ group.name }}</p>
            <p><strong>Total Students:</strong> {{ group.students_count }}</p>
        </div>

        <div class="btn-group" v-if="selectedGroup">
            <button class="btn btn-sm btn-primary"
                @click="$router.push(`/dashboard/groups/assign/${selectedGroup.id}`)">📌 Assign Students</button>
            <button class="btn btn-sm btn-info" @click="$router.push(`/dashboard/groups/view/${selectedGroup.id}`)">👀
                View Students</button>
            <button class="btn btn-sm btn-warning"
                @click="$router.push(`/dashboard/groups/edit/${selectedGroup.id}`)">✏️ Edit</button>
            <button class="btn btn-sm btn-danger" @click="deleteGroup(selectedGroup.id)">🗑️ Delete</button>
        </div>
    </div>
</template>

<script>
export default {
    data() {
        return {
            selectedGroup: null,
            groups: []
        };
    },
    methods: {
        async fetchGroups() {
            try {
                const response = await this.$api.get('/groups');
                this.groups = response.data;
            } catch (error) {
                console.error("Error fetching groups:", error);
            }
        },
        selectGroup(group) {
            this.selectedGroup = group;
        },
        async deleteGroup(id) {
            if (!confirm("Are you sure you want to delete this group?")) return;
            try {
                await this.$api.delete(`/groups/${id}`);
                this.groups = this.groups.filter(group => group.id !== id);
                this.selectedGroup = null;
            } catch (error) {
                console.error("Error deleting group:", error);
            }
        }
    },
    mounted() {
        this.fetchGroups();
    }
};
</script>

<style scoped>
.group-list {
    padding: 20px;
    background: white;
    border-radius: 10px;
    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
}

.group-card {
    background: #f8f9fa;
    padding: 15px;
    border-radius: 10px;
    margin-bottom: 10px;
    cursor: pointer;
}

.group-card.selected {
    background: #d1ecf1;
    border: 2px solid #0c5460;
}

.btn-group {
    display: flex;
    flex-wrap: wrap;
    gap: 5px;
    margin-top: 10px;
    justify-content: center;
}

@media (max-width: 768px) {
    .btn-group {
        flex-direction: column;
        align-items: stretch;
    }
}
</style>
